import { useUserPreferencesValue } from '@/features/auth/preferences';

/**
 * Assinatura do atendente: prefixa `*Nome:*\n` no texto/legenda. Idempotente
 * (não duplica se o texto já começa com ela). Usada pelo composer e pelo
 * agendamento de mensagens.
 */
export function applySignature(
  text: string,
  userName: string | undefined,
  enabled: boolean,
): string {
  if (!enabled || !userName || !text.trim()) return text;
  const prefix = `*${userName}:*\n`;
  if (text.startsWith(prefix)) return text;
  return `${prefix}${text}`;
}

/**
 * Separa a assinatura `*Nome:*\n` do texto — usado na EDIÇÃO: o campo mostra
 * só o texto; ao salvar, a assinatura segue o botão de assinatura NAQUELE
 * momento (applySignature), não como a msg foi enviada. Sem assinatura →
 * prefixo vazio.
 */
export function separarAssinatura(text: string): { prefixo: string; texto: string } {
  const m = /^\*[^*\n]+:\*\n/.exec(text);
  if (!m) return { prefixo: '', texto: text };
  return { prefixo: m[0], texto: text.slice(m[0].length) };
}

/**
 * O gestor travou a assinatura (allow_disable_signature=false)? Aí ela sai
 * sempre, sem opção de desligar — mesma regra do botão de assinatura do
 * composer.
 */
export function useAssinaturaTravada(): boolean {
  return !(useUserPreferencesValue().data?.allowDisableSignature ?? true);
}
